module.exports = __webpack_public_path__ + "img/respecth-mech.4520b3a2.png";